import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { v4 as uuidv4 } from 'uuid';

import { DATE_FORMAT } from '@/constants/date.constants';
import { ticketAtom } from '@/pages/Ticket';

const TemplateCustomDataLogsData = () => {
  const [{ custom_data }] = useAtom(ticketAtom);

  return (
    <>
      <Divider sx={{ borderWidth: '1px' }} />
      <Typography variant="h5">
        Details of the requested Log Data Restore:
      </Typography>
      <TableContainer>
        <Table style={{ display: 'table', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 0, width: '10rem' }}>Start Date</TableCell>
              <TableCell sx={{ py: 0 }}>End Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={uuidv4()}>
              <TableCell
                sx={{
                  py: 1,
                  textTransform: 'uppercase'
                }}
              >
                {dayjs(custom_data?.logs_data?.start_date).format(DATE_FORMAT)}
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  wordWrap: 'break-word'
                }}
              >
                {dayjs(custom_data?.logs_data?.end_date).format(DATE_FORMAT)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplateCustomDataLogsData;
